const PARSE_FIELDS = [
  "header_row_number",
  "first_data_row_number",
  "delimiter",
  "quote_char",
  "character_set",
  "sheet_number",
]

export function parseSettingsParams(formId) {
  const params = new URLSearchParams()
  const form = formId ? document.getElementById(formId) : null
  if (!form) return params

  PARSE_FIELDS.forEach((field) => {
    const name = `file_layout_draft[${field}]`
    const element = form.elements[name]
    if (element) params.set(name, element.value)
  })
  return params
}

export function selectedSampleId(selectId) {
  const select = selectId ? document.getElementById(selectId) : null
  return select && select.value ? select.value : null
}
